const trimSlash = (value) => String(value || "").replace(/\/+$/, "");

const parse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const eventSportStreamUrl = (baseUrl, idevent, idsport) => {
  const eventId = Number(idevent);
  const sportId = Number(idsport);
  if (!eventId || !sportId) return null;
  return `${trimSlash(baseUrl)}/api/hayllis/v2/live/events/${eventId}/sports/${sportId}/stream`;
};

export const centralDateStreamUrl = (baseUrl, date) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(date || ""))) return null;
  return `${trimSlash(baseUrl)}/api/hayllis/v2/live/central/stream?date=${encodeURIComponent(date)}`;
};

export const createMatchSnapshotSseClient = ({
  url,
  onConnected,
  onSnapshot,
  onError,
}) => {
  if (!url) throw new Error("URL SSE inválida.");
  const source = new EventSource(url);
  const connected = (event) => onConnected?.(parse(event.data), event);
  const snapshot = (event) => {
    const payload = parse(event.data);
    if (payload?.match) onSnapshot?.(payload.match, event);
  };
  const error = (event) => onError?.(event);

  source.addEventListener("connected", connected);
  source.addEventListener("match_snapshot", snapshot);
  source.addEventListener("error", error);

  return {
    close() {
      source.removeEventListener("connected", connected);
      source.removeEventListener("match_snapshot", snapshot);
      source.removeEventListener("error", error);
      source.close();
    },
  };
};

